const animations = (): void => {
  const classes = { sectionVisible: 'section--visible' };

  const selectors = {
    bodyMain: 'main.main.main--fade-in-sections',
    mainSections: 'main.main.main--fade-in-sections section.section',
  };

  const main = document.querySelector(selectors.bodyMain);

  if (main) {
    const mainSections = main.querySelectorAll(selectors.mainSections);

    mainSections.forEach((section) => {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            const section = entry.target;
            if (entry.isIntersecting) {
              section.classList.add(classes.sectionVisible);
            } else {
              section.classList.remove(classes.sectionVisible);
            }
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0 }
      );

      observer.observe(section);
    });
  }
};

export default animations;
